import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLockOpen } from '@fortawesome/free-solid-svg-icons';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import useAlert from '../../../Alerts/useAlert';
import usePrivileges from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';

interface UnlockLotButtonProps {
    setLoading: Dispatch<SetStateAction<boolean>>
}
function UnlockLotButton({ setLoading }: UnlockLotButtonProps) {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const { admin, supervisor } = usePrivileges();

    const { lotDetail: { summary: { lotNumber, isLocked } }, getLotDetail } = useContext(LotDetailContext);

    const unlockLot = async () => {
        setLoading(true);

        fetchDataAuthenticated(`api/v1/lot/${lotNumber}/unlock`, 'PUT')
            .then(async response => {
                if (response.ok) {
                    setAlert("success", "Success", `Lot ${lotNumber} is now unlocked`);
                    getLotDetail();
                } else {
                    let message = await response.text();
                    throw new Error(`Failed to unlock the lot. ${message}`);
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <>
            <Button variant="warning"
                hidden={(!admin && !supervisor) || !isLocked}
                onClick={() => unlockLot()}>
                <FontAwesomeIcon icon={faLockOpen} className="me-1" />
                {t<string>('LotDetails.Summary.UnlockLot')}
            </Button>
        </>
    );
}

export default UnlockLotButton;